import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "html-events"
    }}>{`HTML Events`}</h1>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "BaseUIEvent.md"
        }}>{`BaseUIEvent`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "CloseEvent.md"
        }}>{`CloseEvent`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "DragEvent.md"
        }}>{`DragEvent`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "ErrorEvent.md"
        }}>{`ErrorEvent`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Event.md"
        }}>{`Event`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "EventTarget.md"
        }}>{`EventTarget`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "GestureEvent.md"
        }}>{`GestureEvent`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "KeyboardEvent.md"
        }}>{`KeyboardEvent`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "MessageEvent.md"
        }}>{`MessageEvent`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "PointerEvent.md"
        }}>{`PointerEvent`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "ProgressEvent.md"
        }}>{`ProgressEvent`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      